export default __webpack_public_path__ + "static/notify_views-4ae097f4c3a2e7fd9e2408b812c5170f.png";